import {Button} from "antd";
import {ServiceOrderWorkDeliveryHeaderProps} from ".";
import {useGetStoreServicesOrdersContext} from "../../../../../../../../../service-feature/useCases/get-orders/context";

export type ServiceOrderDeliverWorkButtonProps = {
  status: ServiceOrderWorkDeliveryHeaderProps["status"];
  hasMaxedOutDelivery: boolean;
};

export function ServiceOrderDeliverWorkButton({
  status,
  hasMaxedOutDelivery,
}: ServiceOrderDeliverWorkButtonProps) {
  const {dispatch} = useGetStoreServicesOrdersContext();
  return (
    <div>
      {!hasMaxedOutDelivery && status === "inprogress" ? (
        <Button
          size="small"
          type="primary"
          onClick={() =>
            dispatch({
              type: "set-active-store-service-order-drawer",
              payload: "deliver-work",
            })
          }
        >
          Deliver your work
        </Button>
      ) : null}
    </div>
  );
}
